/**
 * @module unterwegs.sidebar.PlantService
 */

/**
 * The Plant service uses the
 * womeninbotany backend to get plant names
 * @constructor
 * @param {angular.$http} $http Angular http service.
 * @ngInject
 * @ngdoc service
 * @ngname womeninbotanyPlant
 */
const exports = function($http, womeninbotanyServerURL) {

  /**
  * @type {angular.$http}
  * @private
  */
  this.http_ = $http;

  /**
  * @type {string}
  * @private
  */
  this.baseURL_ = womeninbotanyServerURL.replace(/\/$/, '');  // only works if no remote host is passed via cmd
};

/**
 * @param {string} search
 * @return {angular.$q.Promise} Promise.
 * @export
*/
exports.prototype.searchNames = function(search) {
  const url = `${this.baseURL_}/species/list?name=${search}`;
  return this.http_.get(url).then(
    (response) => {
      return response.data;
    },
    (message) => {
      console.log(message);
    }
  );
};


/**
 * @type {!angular.Module}
 */
exports.module = angular.module('womeninbotanyPlantService', []);

exports.module.service('womeninbotanyPlantService', exports);

export default exports;
